// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/dispatch_group/v1/service

import type {
  AddDispatchGroupDeliveryPointRequest,
  AddDispatchGroupDeliveryPointResponse,
  AddGridServiceToDispatchGroupRequest,
  AddGridServiceToDispatchGroupResponse,
  CreateDispatchGroupRequest,
  CreateDispatchGroupResponse,
  CreateDispatchIndicatorRequest,
  CreateDispatchIndicatorResponse,
  CreateDispatcherRequest,
  CreateDispatcherResponse,
  DeleteDispatchGroupRequest,
  DeleteDispatchGroupResponse,
  DeleteDispatchIndicatorRequest,
  DeleteDispatchIndicatorResponse,
  DeleteDispatcherRequest,
  DeleteDispatcherResponse,
  GetDispatchGroupRequest,
  GetDispatchGroupResponse,
  GetDispatchIndicatorRequest,
  GetDispatchIndicatorResponse,
  GetDispatcherRequest,
  GetDispatcherResponse,
  ListDispatchGroupDeliveryPointsRequest,
  ListDispatchGroupDeliveryPointsResponse,
  ListDispatchGroupGridServicesRequest,
  ListDispatchGroupGridServicesResponse,
  ListDispatchGroupsRequest,
  ListDispatchGroupsResponse,
  ListDispatchIndicatorsRequest,
  ListDispatchIndicatorsResponse,
  ListDispatchersRequest,
  ListDispatchersResponse,
  RemoveDispatchGroupDeliveryPointRequest,
  RemoveDispatchGroupDeliveryPointResponse,
  RemoveGridServiceFromDispatchGroupRequest,
  RemoveGridServiceFromDispatchGroupResponse,
  RestoreDispatchGroupRequest,
  RestoreDispatchGroupResponse,
  UpdateDispatchGroupGridServiceRequest,
  UpdateDispatchGroupGridServiceResponse,
  UpdateDispatchGroupRequest,
  UpdateDispatchGroupResponse,
  UpdateDispatchIndicatorRequest,
  UpdateDispatchIndicatorResponse,
  UpdateDispatcherRequest,
  UpdateDispatcherResponse,
} from "@proto/gen/dispatch_group/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getDispatchGroupClient } from "./client"

export interface DispatchGroupServiceState {
  /** State for createDispatchGroup method */
  createDispatchGroup: MethodState<CreateDispatchGroupResponse>
  /** State for getDispatchGroup method */
  getDispatchGroup: MethodState<GetDispatchGroupResponse>
  /** State for listDispatchGroups method */
  listDispatchGroups: MethodState<ListDispatchGroupsResponse>
  /** State for updateDispatchGroup method */
  updateDispatchGroup: MethodState<UpdateDispatchGroupResponse>
  /** State for deleteDispatchGroup method */
  deleteDispatchGroup: MethodState<DeleteDispatchGroupResponse>
  /** State for restoreDispatchGroup method */
  restoreDispatchGroup: MethodState<RestoreDispatchGroupResponse>
  /** State for addGridServiceToDispatchGroup method */
  addGridServiceToDispatchGroup: MethodState<AddGridServiceToDispatchGroupResponse>
  /** State for removeGridServiceFromDispatchGroup method */
  removeGridServiceFromDispatchGroup: MethodState<RemoveGridServiceFromDispatchGroupResponse>
  /** State for updateDispatchGroupGridService method */
  updateDispatchGroupGridService: MethodState<UpdateDispatchGroupGridServiceResponse>
  /** State for listDispatchGroupGridServices method */
  listDispatchGroupGridServices: MethodState<ListDispatchGroupGridServicesResponse>
  /** State for createDispatchIndicator method */
  createDispatchIndicator: MethodState<CreateDispatchIndicatorResponse>
  /** State for getDispatchIndicator method */
  getDispatchIndicator: MethodState<GetDispatchIndicatorResponse>
  /** State for listDispatchIndicators method */
  listDispatchIndicators: MethodState<ListDispatchIndicatorsResponse>
  /** State for updateDispatchIndicator method */
  updateDispatchIndicator: MethodState<UpdateDispatchIndicatorResponse>
  /** State for deleteDispatchIndicator method */
  deleteDispatchIndicator: MethodState<DeleteDispatchIndicatorResponse>
  /** State for addDispatchGroupDeliveryPoint method */
  addDispatchGroupDeliveryPoint: MethodState<AddDispatchGroupDeliveryPointResponse>
  /** State for removeDispatchGroupDeliveryPoint method */
  removeDispatchGroupDeliveryPoint: MethodState<RemoveDispatchGroupDeliveryPointResponse>
  /** State for listDispatchGroupDeliveryPoints method */
  listDispatchGroupDeliveryPoints: MethodState<ListDispatchGroupDeliveryPointsResponse>
  /** State for createDispatcher method */
  createDispatcher: MethodState<CreateDispatcherResponse>
  /** State for getDispatcher method */
  getDispatcher: MethodState<GetDispatcherResponse>
  /** State for listDispatchers method */
  listDispatchers: MethodState<ListDispatchersResponse>
  /** State for updateDispatcher method */
  updateDispatcher: MethodState<UpdateDispatcherResponse>
  /** State for deleteDispatcher method */
  deleteDispatcher: MethodState<DeleteDispatcherResponse>
  /** Call createDispatchGroup method */
  createDispatchGroupAsync: (
    req: CreateDispatchGroupRequest
  ) => Promise<CreateDispatchGroupResponse>
  /** Call getDispatchGroup method */
  getDispatchGroupAsync: (req: GetDispatchGroupRequest) => Promise<GetDispatchGroupResponse>
  /** Call listDispatchGroups method */
  listDispatchGroupsAsync: (req: ListDispatchGroupsRequest) => Promise<ListDispatchGroupsResponse>
  /** Call updateDispatchGroup method */
  updateDispatchGroupAsync: (
    req: UpdateDispatchGroupRequest
  ) => Promise<UpdateDispatchGroupResponse>
  /** Call deleteDispatchGroup method */
  deleteDispatchGroupAsync: (
    req: DeleteDispatchGroupRequest
  ) => Promise<DeleteDispatchGroupResponse>
  /** Call restoreDispatchGroup method */
  restoreDispatchGroupAsync: (
    req: RestoreDispatchGroupRequest
  ) => Promise<RestoreDispatchGroupResponse>
  /** Call addGridServiceToDispatchGroup method */
  addGridServiceToDispatchGroupAsync: (
    req: AddGridServiceToDispatchGroupRequest
  ) => Promise<AddGridServiceToDispatchGroupResponse>
  /** Call removeGridServiceFromDispatchGroup method */
  removeGridServiceFromDispatchGroupAsync: (
    req: RemoveGridServiceFromDispatchGroupRequest
  ) => Promise<RemoveGridServiceFromDispatchGroupResponse>
  /** Call updateDispatchGroupGridService method */
  updateDispatchGroupGridServiceAsync: (
    req: UpdateDispatchGroupGridServiceRequest
  ) => Promise<UpdateDispatchGroupGridServiceResponse>
  /** Call listDispatchGroupGridServices method */
  listDispatchGroupGridServicesAsync: (
    req: ListDispatchGroupGridServicesRequest
  ) => Promise<ListDispatchGroupGridServicesResponse>
  /** Call createDispatchIndicator method */
  createDispatchIndicatorAsync: (
    req: CreateDispatchIndicatorRequest
  ) => Promise<CreateDispatchIndicatorResponse>
  /** Call getDispatchIndicator method */
  getDispatchIndicatorAsync: (
    req: GetDispatchIndicatorRequest
  ) => Promise<GetDispatchIndicatorResponse>
  /** Call listDispatchIndicators method */
  listDispatchIndicatorsAsync: (
    req: ListDispatchIndicatorsRequest
  ) => Promise<ListDispatchIndicatorsResponse>
  /** Call updateDispatchIndicator method */
  updateDispatchIndicatorAsync: (
    req: UpdateDispatchIndicatorRequest
  ) => Promise<UpdateDispatchIndicatorResponse>
  /** Call deleteDispatchIndicator method */
  deleteDispatchIndicatorAsync: (
    req: DeleteDispatchIndicatorRequest
  ) => Promise<DeleteDispatchIndicatorResponse>
  /** Call addDispatchGroupDeliveryPoint method */
  addDispatchGroupDeliveryPointAsync: (
    req: AddDispatchGroupDeliveryPointRequest
  ) => Promise<AddDispatchGroupDeliveryPointResponse>
  /** Call removeDispatchGroupDeliveryPoint method */
  removeDispatchGroupDeliveryPointAsync: (
    req: RemoveDispatchGroupDeliveryPointRequest
  ) => Promise<RemoveDispatchGroupDeliveryPointResponse>
  /** Call listDispatchGroupDeliveryPoints method */
  listDispatchGroupDeliveryPointsAsync: (
    req: ListDispatchGroupDeliveryPointsRequest
  ) => Promise<ListDispatchGroupDeliveryPointsResponse>
  /** Call createDispatcher method */
  createDispatcherAsync: (req: CreateDispatcherRequest) => Promise<CreateDispatcherResponse>
  /** Call getDispatcher method */
  getDispatcherAsync: (req: GetDispatcherRequest) => Promise<GetDispatcherResponse>
  /** Call listDispatchers method */
  listDispatchersAsync: (req: ListDispatchersRequest) => Promise<ListDispatchersResponse>
  /** Call updateDispatcher method */
  updateDispatcherAsync: (req: UpdateDispatcherRequest) => Promise<UpdateDispatcherResponse>
  /** Call deleteDispatcher method */
  deleteDispatcherAsync: (req: DeleteDispatcherRequest) => Promise<DeleteDispatcherResponse>
}

/**
 * Zustand store for DispatchGroupService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useDispatchGroupServiceStore = create<DispatchGroupServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          createDispatchGroup: createMethodState<CreateDispatchGroupResponse>(),
          async createDispatchGroupAsync(req: CreateDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().createDispatchGroup(req)
              set((state) => {
                const slot = state.createDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDispatchGroup: createMethodState<GetDispatchGroupResponse>(),
          async getDispatchGroupAsync(req: GetDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().getDispatchGroup(req)
              set((state) => {
                const slot = state.getDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDispatchGroups: createMethodState<ListDispatchGroupsResponse>(),
          async listDispatchGroupsAsync(req: ListDispatchGroupsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDispatchGroups
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().listDispatchGroups(req)
              set((state) => {
                const slot = state.listDispatchGroups
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDispatchGroups
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDispatchGroup: createMethodState<UpdateDispatchGroupResponse>(),
          async updateDispatchGroupAsync(req: UpdateDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().updateDispatchGroup(req)
              set((state) => {
                const slot = state.updateDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDispatchGroup: createMethodState<DeleteDispatchGroupResponse>(),
          async deleteDispatchGroupAsync(req: DeleteDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().deleteDispatchGroup(req)
              set((state) => {
                const slot = state.deleteDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          restoreDispatchGroup: createMethodState<RestoreDispatchGroupResponse>(),
          async restoreDispatchGroupAsync(req: RestoreDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.restoreDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().restoreDispatchGroup(req)
              set((state) => {
                const slot = state.restoreDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.restoreDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          addGridServiceToDispatchGroup: createMethodState<AddGridServiceToDispatchGroupResponse>(),
          async addGridServiceToDispatchGroupAsync(req: AddGridServiceToDispatchGroupRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.addGridServiceToDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().addGridServiceToDispatchGroup(req)
              set((state) => {
                const slot = state.addGridServiceToDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.addGridServiceToDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          removeGridServiceFromDispatchGroup:
            createMethodState<RemoveGridServiceFromDispatchGroupResponse>(),
          async removeGridServiceFromDispatchGroupAsync(
            req: RemoveGridServiceFromDispatchGroupRequest
          ) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.removeGridServiceFromDispatchGroup
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } =
                await getDispatchGroupClient().removeGridServiceFromDispatchGroup(req)
              set((state) => {
                const slot = state.removeGridServiceFromDispatchGroup
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.removeGridServiceFromDispatchGroup
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDispatchGroupGridService:
            createMethodState<UpdateDispatchGroupGridServiceResponse>(),
          async updateDispatchGroupGridServiceAsync(req: UpdateDispatchGroupGridServiceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDispatchGroupGridService
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } =
                await getDispatchGroupClient().updateDispatchGroupGridService(req)
              set((state) => {
                const slot = state.updateDispatchGroupGridService
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDispatchGroupGridService
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDispatchGroupGridServices: createMethodState<ListDispatchGroupGridServicesResponse>(),
          async listDispatchGroupGridServicesAsync(req: ListDispatchGroupGridServicesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDispatchGroupGridServices
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().listDispatchGroupGridServices(req)
              set((state) => {
                const slot = state.listDispatchGroupGridServices
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDispatchGroupGridServices
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createDispatchIndicator: createMethodState<CreateDispatchIndicatorResponse>(),
          async createDispatchIndicatorAsync(req: CreateDispatchIndicatorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDispatchIndicator
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().createDispatchIndicator(req)
              set((state) => {
                const slot = state.createDispatchIndicator
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDispatchIndicator
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDispatchIndicator: createMethodState<GetDispatchIndicatorResponse>(),
          async getDispatchIndicatorAsync(req: GetDispatchIndicatorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDispatchIndicator
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().getDispatchIndicator(req)
              set((state) => {
                const slot = state.getDispatchIndicator
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDispatchIndicator
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDispatchIndicators: createMethodState<ListDispatchIndicatorsResponse>(),
          async listDispatchIndicatorsAsync(req: ListDispatchIndicatorsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDispatchIndicators
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().listDispatchIndicators(req)
              set((state) => {
                const slot = state.listDispatchIndicators
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDispatchIndicators
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDispatchIndicator: createMethodState<UpdateDispatchIndicatorResponse>(),
          async updateDispatchIndicatorAsync(req: UpdateDispatchIndicatorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDispatchIndicator
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().updateDispatchIndicator(req)
              set((state) => {
                const slot = state.updateDispatchIndicator
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDispatchIndicator
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDispatchIndicator: createMethodState<DeleteDispatchIndicatorResponse>(),
          async deleteDispatchIndicatorAsync(req: DeleteDispatchIndicatorRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDispatchIndicator
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().deleteDispatchIndicator(req)
              set((state) => {
                const slot = state.deleteDispatchIndicator
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDispatchIndicator
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          addDispatchGroupDeliveryPoint: createMethodState<AddDispatchGroupDeliveryPointResponse>(),
          async addDispatchGroupDeliveryPointAsync(req: AddDispatchGroupDeliveryPointRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.addDispatchGroupDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().addDispatchGroupDeliveryPoint(req)
              set((state) => {
                const slot = state.addDispatchGroupDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.addDispatchGroupDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          removeDispatchGroupDeliveryPoint:
            createMethodState<RemoveDispatchGroupDeliveryPointResponse>(),
          async removeDispatchGroupDeliveryPointAsync(
            req: RemoveDispatchGroupDeliveryPointRequest
          ) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.removeDispatchGroupDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } =
                await getDispatchGroupClient().removeDispatchGroupDeliveryPoint(req)
              set((state) => {
                const slot = state.removeDispatchGroupDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.removeDispatchGroupDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDispatchGroupDeliveryPoints:
            createMethodState<ListDispatchGroupDeliveryPointsResponse>(),
          async listDispatchGroupDeliveryPointsAsync(req: ListDispatchGroupDeliveryPointsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDispatchGroupDeliveryPoints
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } =
                await getDispatchGroupClient().listDispatchGroupDeliveryPoints(req)
              set((state) => {
                const slot = state.listDispatchGroupDeliveryPoints
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDispatchGroupDeliveryPoints
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createDispatcher: createMethodState<CreateDispatcherResponse>(),
          async createDispatcherAsync(req: CreateDispatcherRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDispatcher
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().createDispatcher(req)
              set((state) => {
                const slot = state.createDispatcher
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDispatcher
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDispatcher: createMethodState<GetDispatcherResponse>(),
          async getDispatcherAsync(req: GetDispatcherRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDispatcher
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().getDispatcher(req)
              set((state) => {
                const slot = state.getDispatcher
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDispatcher
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          listDispatchers: createMethodState<ListDispatchersResponse>(),
          async listDispatchersAsync(req: ListDispatchersRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDispatchers
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().listDispatchers(req)
              set((state) => {
                const slot = state.listDispatchers
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDispatchers
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDispatcher: createMethodState<UpdateDispatcherResponse>(),
          async updateDispatcherAsync(req: UpdateDispatcherRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDispatcher
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().updateDispatcher(req)
              set((state) => {
                const slot = state.updateDispatcher
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDispatcher
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDispatcher: createMethodState<DeleteDispatcherResponse>(),
          async deleteDispatcherAsync(req: DeleteDispatcherRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDispatcher
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDispatchGroupClient().deleteDispatcher(req)
              set((state) => {
                const slot = state.deleteDispatcher
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDispatcher
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "dispatchGroup-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<DispatchGroupServiceState> = {}
          {
            const slot = state.createDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDispatchGroupResponse>
            }
          }
          {
            const slot = state.getDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDispatchGroupResponse>
            }
          }
          {
            const slot = state.listDispatchGroups
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDispatchGroups = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDispatchGroupsResponse>
            }
          }
          {
            const slot = state.updateDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDispatchGroupResponse>
            }
          }
          {
            const slot = state.deleteDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDispatchGroupResponse>
            }
          }
          {
            const slot = state.restoreDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.restoreDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<RestoreDispatchGroupResponse>
            }
          }
          {
            const slot = state.addGridServiceToDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.addGridServiceToDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<AddGridServiceToDispatchGroupResponse>
            }
          }
          {
            const slot = state.removeGridServiceFromDispatchGroup
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.removeGridServiceFromDispatchGroup = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<RemoveGridServiceFromDispatchGroupResponse>
            }
          }
          {
            const slot = state.updateDispatchGroupGridService
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDispatchGroupGridService = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDispatchGroupGridServiceResponse>
            }
          }
          {
            const slot = state.listDispatchGroupGridServices
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDispatchGroupGridServices = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDispatchGroupGridServicesResponse>
            }
          }
          {
            const slot = state.createDispatchIndicator
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDispatchIndicator = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDispatchIndicatorResponse>
            }
          }
          {
            const slot = state.getDispatchIndicator
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDispatchIndicator = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDispatchIndicatorResponse>
            }
          }
          {
            const slot = state.listDispatchIndicators
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDispatchIndicators = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDispatchIndicatorsResponse>
            }
          }
          {
            const slot = state.updateDispatchIndicator
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDispatchIndicator = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDispatchIndicatorResponse>
            }
          }
          {
            const slot = state.deleteDispatchIndicator
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDispatchIndicator = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDispatchIndicatorResponse>
            }
          }
          {
            const slot = state.addDispatchGroupDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.addDispatchGroupDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<AddDispatchGroupDeliveryPointResponse>
            }
          }
          {
            const slot = state.removeDispatchGroupDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.removeDispatchGroupDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<RemoveDispatchGroupDeliveryPointResponse>
            }
          }
          {
            const slot = state.listDispatchGroupDeliveryPoints
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDispatchGroupDeliveryPoints = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDispatchGroupDeliveryPointsResponse>
            }
          }
          {
            const slot = state.createDispatcher
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDispatcher = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDispatcherResponse>
            }
          }
          {
            const slot = state.getDispatcher
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDispatcher = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDispatcherResponse>
            }
          }
          {
            const slot = state.listDispatchers
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDispatchers = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDispatchersResponse>
            }
          }
          {
            const slot = state.updateDispatcher
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDispatcher = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDispatcherResponse>
            }
          }
          {
            const slot = state.deleteDispatcher
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDispatcher = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDispatcherResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as DispatchGroupServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "DispatchGroupService" }
  )
)
